import { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { Footer } from '../template/Footer';
import { Navbar } from '../template/navbar/Navbar';
import PageLoader from '../template/PageLoader';

const UserLayout = () => {
  return (
    <div className="flex flex-col relative flex-auto min-h-screen min-w-0 w-full">

      <Navbar />
      <div className="h-full flex flex-auto flex-col justify-between mt-16">
        <Suspense fallback={<PageLoader />}>
          <main className="relative h-full flex flex-auto flex-col p-2 sm:px-6 md:px-8 sm:py-6 container">
            <Outlet />
          </main>
        </Suspense>
        <Footer />
      </div>
      <div className="pointer-events-none absolute top-0 left-0 w-[300px] h-[300px] bg-gradient-to-br from-primary/30 to-transparent rounded-full blur-3xl animate-float" />
      <div className="pointer-events-none absolute bottom-20 right-10 w-[250px] h-[250px] bg-gradient-to-tr from-primary/20 to-transparent rounded-full blur-2xl animate-float-delay" />
      <div className="pointer-events-none absolute bottom-0 left-1/2 transform -translate-x-1/2 w-[400px] h-[400px] bg-gradient-to-t from-primary/10 to-transparent rounded-full blur-3xl animate-float-slow" />

    </div>
  );
};

export default UserLayout;
